import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, TrendingDown, TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MarketPulseStrip = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    fetch(`${API}/public/market-intel/summary`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null)).then(setD).catch(() => {});
  }, []);
  if (!d) return null;
  const items = [
    { label: "Li₂CO₃ China", value: `¥${Math.round(d.lithium.cny_mt).toLocaleString()}/MT`, sub: `$${Math.round(d.lithium.usd_mt).toLocaleString()}/MT`, chg: d.lithium.d7_pct },
    { label: "GFY LFP cell index", value: `$${d.lfp_cell.usd_kwh_regression}/kWh`, sub: `314Ah ≈ $${d.lfp_cell.cell_314ah_usd}`, chg: null },
    { label: "BESS container (EXW CN)", value: `$${d.bess.usd_kwh_regression}/kWh`, sub: `ex-factory · India landed ≈ $${d.bess.landed_incl_gst_usd_kwh || "—"}/kWh incl. all`, chg: null },
    { label: "Copper LME", value: `$${Math.round(d.copper.lme_usd_mt).toLocaleString()}/MT`, sub: `Mandi ₹${d.copper.mandi_inr_kg}/kg`, chg: d.copper.d1_pct },
  ];
  return (
    <section className="border-y border-white/10 bg-gf-surface/60" data-testid="market-pulse-strip">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-8 py-6">
        <div className="flex flex-wrap items-center gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[3px] text-gf-primary">GFY Market Pulse</p>
          <Link to="/marketpulse" data-testid="market-pulse-link"
            className="ml-auto inline-flex items-center gap-1 font-body text-xs font-bold text-gf-primary hover:brightness-125 transition-[filter]"
            style={{ color: "rgb(var(--gf-primary))", textShadow: "0 0 12px rgb(var(--gf-primary) / 0.55)" }}>
            Full tracker, indices & IEEMA calculator <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-3">
          {items.map((it) => (
            <div key={it.label} className="border border-white/10 bg-gf-bg/60 px-4 py-3" data-testid={`mp-strip-${it.label.slice(0, 6)}`}>
              <p className="font-mono text-[8px] uppercase tracking-wider text-gf-muted">{it.label}</p>
              <p className="font-heading font-black text-gf-text text-lg mt-0.5">{it.value}
                {it.chg !== null && it.chg !== undefined && (
                  <span className={`ml-2 font-mono text-[9px] ${it.chg <= 0 ? "text-gf-primary" : "text-amber-400"}`}>
                    {it.chg <= 0 ? <TrendingDown className="w-3 h-3 inline" /> : <TrendingUp className="w-3 h-3 inline" />} {it.chg > 0 ? "+" : ""}{it.chg}%
                  </span>
                )}
              </p>
              <p className="font-mono text-[9px] text-gf-muted">{it.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
